import { contactUsAtom } from "@core/contact-us/atom";
import { Button } from "@design-system/components/Button";
import {
  EmailInput,
  TextareaInput,
  TextInput,
} from "@design-system/components/Form";
import { errorToast } from "@design-system/components/toast";
import { userAtom } from "@framework/config/atoms";
import { useAction } from "@framework/shared/hooks";
import { trans, plainTrans } from "@mongez/localization";
import { Form, FormSubmitOptions } from "@mongez/react-form";

export function ContactForm() {
  const user = userAtom.useValue();
  const contactUsAction = useAction("/contact-us");

  const sendMessage = async ({ values, form }: FormSubmitOptions) => {
    const value = await contactUsAction(values);

    form.submitting(false);

    if (value.error) {
      return errorToast(value.error);
    }

    contactUsAtom.update(true);
  };

  return (
    <div>
      <div className="flex flex-col">
        <div className="w-full">
          <Form onSubmit={sendMessage}>
            <div className="mb-12 flex w-full flex-col gap-4">
              <TextInput
                placeholder={plainTrans("name")}
                name="name"
                defaultValue={user.name}
                required
                className="rounded-[0.6rem] px-4 py-6"
              />
              <EmailInput
                placeholder={plainTrans("email")}
                defaultValue={user.email}
                name="email"
                required
                className="rounded-[0.6rem] px-4 py-6"
              />
              <TextInput
                placeholder={plainTrans("phoneNumber")}
                defaultValue={user.phoneNumber}
                name="phoneNumber"
                className="rounded-[0.6rem] px-4 py-6"
              />
              <TextareaInput
                placeholder={plainTrans("message")}
                minRows={6}
                name="message"
                required
                className="rounded-[0.6rem]"
              />
              <Button className="h-11 w-full bg-primary text-primary-foreground hover:bg-primary/90 shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105 dark:bg-gray-100 dark:text-gray-900 dark:hover:bg-gray-200 dark:border dark:border-gray-300" type="submit">
                {trans("send")}
              </Button>
            </div>
          </Form>
        </div>
      </div>
    </div>
  );
}
